import { createAction, ActionCreator, Action } from '@ngrx/store'

export enum LoadingActionTypes {
  START_LOADING = '[Loading] Start Loading',
  STOP_LOADING = '[Loading] Stop Loading',
  START_LOADING_CROPS = '[Loading] Start Loading Crops',
  STOP_LOADING_CROPS = '[Loading] Stop Loading Crops',
  START_LOADING_FARMS = '[Loading] Start Loading Farms',
  STOP_LOADING_FARMS = '[Loading] Stop Loading Farms',
  START_LOADING_VARIETIES = '[Loading] Start Loading Varieties',
  STOP_LOADING_VARIETIES = '[Loading] Stop Loading Varieties',
  START_LOADING_SPECIFICATIONS = '[Loading] Start Loading Specifications',
  STOP_LOADING_SPECIFICATIONS = '[Loading] Stop Loading Specifications',
  CLEAR_LOADING = '[Loading] Clear Loading',
}

export const startLoading: ActionCreator<
  LoadingActionTypes.START_LOADING,
  () => Action<LoadingActionTypes.START_LOADING>
> = createAction(LoadingActionTypes.START_LOADING)
export const stopLoading: ActionCreator<
  LoadingActionTypes.STOP_LOADING,
  () => Action<LoadingActionTypes.STOP_LOADING>
> = createAction(LoadingActionTypes.STOP_LOADING)
export const startLoadingFarms: ActionCreator<
  LoadingActionTypes.START_LOADING_FARMS,
  () => Action<LoadingActionTypes.START_LOADING_FARMS>
> = createAction(LoadingActionTypes.START_LOADING_FARMS)
export const stopLoadingFarms: ActionCreator<
  LoadingActionTypes.STOP_LOADING_FARMS,
  () => Action<LoadingActionTypes.STOP_LOADING_FARMS>
> = createAction(LoadingActionTypes.STOP_LOADING_FARMS)
export const startLoadingCrops: ActionCreator<
  LoadingActionTypes.START_LOADING_CROPS,
  () => Action<LoadingActionTypes.START_LOADING_CROPS>
> = createAction(LoadingActionTypes.START_LOADING_CROPS)
export const stopLoadingCrops: ActionCreator<
  LoadingActionTypes.STOP_LOADING_CROPS,
  () => Action<LoadingActionTypes.STOP_LOADING_CROPS>
> = createAction(LoadingActionTypes.STOP_LOADING_CROPS)
export const startLoadingVarieties: ActionCreator<
  LoadingActionTypes.START_LOADING_VARIETIES,
  () => Action<LoadingActionTypes.START_LOADING_VARIETIES>
> = createAction(LoadingActionTypes.START_LOADING_VARIETIES)
export const stopLoadingVarieties: ActionCreator<
  LoadingActionTypes.STOP_LOADING_VARIETIES,
  () => Action<LoadingActionTypes.STOP_LOADING_VARIETIES>
> = createAction(LoadingActionTypes.STOP_LOADING_VARIETIES)
export const startLoadingSpecifications: ActionCreator<
  LoadingActionTypes.START_LOADING_SPECIFICATIONS,
  () => Action<LoadingActionTypes.START_LOADING_SPECIFICATIONS>
> = createAction(LoadingActionTypes.START_LOADING_SPECIFICATIONS)
export const stopLoadingSpecifications: ActionCreator<
  LoadingActionTypes.STOP_LOADING_SPECIFICATIONS,
  () => Action<LoadingActionTypes.STOP_LOADING_SPECIFICATIONS>
> = createAction(LoadingActionTypes.STOP_LOADING_SPECIFICATIONS)
export const clearLoading: ActionCreator<
  LoadingActionTypes.CLEAR_LOADING,
  () => Action<LoadingActionTypes.CLEAR_LOADING>
> = createAction(LoadingActionTypes.CLEAR_LOADING)
